"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var captcha_component_1 = require("./lib/captcha.component");
var captcha_service_1 = require("./lib/captcha.service");
var ReCaptchaModule = (function () {
    function ReCaptchaModule() {
    }
    return ReCaptchaModule;
}());
ReCaptchaModule = __decorate([
    core_1.NgModule({
        declarations: [captcha_component_1.ReCaptchaComponent],
        exports: [captcha_component_1.ReCaptchaComponent],
        providers: [captcha_service_1.RECAPTCHA_SERVICE_PROVIDER]
    })
], ReCaptchaModule);
exports.ReCaptchaModule = ReCaptchaModule;
__export(require("./lib/captcha.component"));



//////////////////
// WEBPACK FOOTER
// ./~/angular2-recaptcha/angular2-recaptcha.js
// module id = ./node_modules/angular2-recaptcha/angular2-recaptcha.js
// module chunks = 4